module.exports = __webpack_public_path__ + "static/font-67dcdf4d3cca066cbbc3b7e48a06743c.woff";